import { render, staticRenderFns } from "./MonitorParagraph.vue?vue&type=template&id=f3f8be7a&scoped=true&"
import script from "./MonitorParagraph.vue?vue&type=script&lang=js&"
export * from "./MonitorParagraph.vue?vue&type=script&lang=js&"
import style0 from "./MonitorParagraph.vue?vue&type=style&index=0&id=f3f8be7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f8be7a",
  null
  
)

export default component.exports